module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-18-56e9c6af737d166e5415cfa0b8a660df.png";